import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Eye: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M5.51172 6C7.16301 4.1552 9.04434 3 12 3C17.5 3 19.28 7 22.78 12C20.9781 14.5742 19.632 16.8834 17.9995 18.5181M16 20.0529C14.8935 20.6594 13.6054 21 12.0005 21C6.50055 21 4.7207 17 1.2207 12C2.22884 10.5598 3.09426 9.20256 3.94697 8M0.707031 0.707031L23.293 23.293M14.1215 14.1213C15.2931 12.9497 15.2931 11.0503 14.1215 9.87868C12.95 8.70711 11.0505 8.70711 9.87891 9.87868'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default Eye
